/* eslint-disable import/no-cycle */

import { call, put, takeEvery, all } from 'redux-saga/effects';
import { commands } from '../../api/api';
import {
  GET_COMMANDS_FOR_MERGE,
  GET_COMMANDS_FOR_MERGE_SUCCESS,
  GET_COMMANDS_FOR_MERGE_FAILURE,
  MERGE_COMMANDS,
  MERGE_COMMANDS_SUCCESS,
  MERGE_COMMANDS_FAILURE
} from './mergeCommandsActions';
import { displayLoading, displaySuccess } from '../../utils/toast/Toast';
import logger from '../../utils/logger';

export function* getCommandsForMerge(action) {
  const closeLoading = displayLoading('Récupérations des commandes en cours');
  try {
    let commandsForMerge = yield all(
      action.payload.map(commandId => call(commands.getCommand, commandId))
    );
    commandsForMerge = commandsForMerge.map(
      commandForMerge => commandForMerge.data.command
    );
    yield put({
      type: GET_COMMANDS_FOR_MERGE_SUCCESS,
      payload: commandsForMerge
    });
  } catch (error) {
    logger(error);
    yield put({ type: GET_COMMANDS_FOR_MERGE_FAILURE });
  } finally {
    closeLoading();
  }
}

export function* mergeCommands(action) {
  const closeLoading = displayLoading('Fusion des commandes en cours');
  try {
    yield call(commands.merge, action.payload);
    yield put({ type: MERGE_COMMANDS_SUCCESS });
    displaySuccess('Fusion des commandes effectuées avec succès');
  } catch (error) {
    logger(error);
    yield put({ type: MERGE_COMMANDS_FAILURE });
  } finally {
    closeLoading();
  }
}

const courseSaga = [
  takeEvery(GET_COMMANDS_FOR_MERGE, getCommandsForMerge),
  takeEvery(MERGE_COMMANDS, mergeCommands)
];

export default courseSaga;
